<template>
  <div>
    <div class="fill-height slider-cont">
      <div class="modal-inside pb-0 no-tab-right-pane">
        <div class="form-title mb-24">Quick Add Lead</div>
        <v-form ref="form">
          <div class="tab-content-wrapper">
            <v-row class="e-row">
              <v-col cols="6" md="6" class="e-col">
                <div>
                  <label>
                    <span class="label-txt"> Name </span>
                    <v-text-field
                      autocomplete="off"
                      solo
                      outlined
                      :rules="rules.name"
                      v-model="form.name"
                      flat
                      hide-details="auto"
                      class="solo-cust"
                    ></v-text-field>
                  </label>
                </div>
              </v-col>

              <v-col cols="12" md="6" class="e-col">
                <label>
                  <span class="label-txt"> Contact No </span>
                </label>
                <v-text-field
                  autocomplete="off"
                  solo
                  outlined
                  v-model="form.contact_no"
                  :rules="rules.contact_no"
                  flat
                  hide-details="auto"
                  class="solo-cust"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="e-row">
              <v-col cols="12" md="6" class="e-col">
                <label>
                  <span class="label-txt"> Influencer </span>
                </label>
                <v-text-field
                  autocomplete="off"
                  solo
                  outlined
                  v-model="form.influencer"
                  :rules="rules.influencer"
                  flat
                  hide-details="auto"
                  class="solo-cust"
                ></v-text-field>
              </v-col>
               <v-col cols="6" md="6" class="e-col">
                <label>
                  <span class="label-txt"> Branch </span>
                </label>
                <v-autocomplete
                  v-model="form.branch_id"
                  :rules="rules.branch_id"
                  :items="branches"
                  item-text="branch"
                  item-value="id"
                  chips
                  autocomplete="off"
                  solo
                  outlined
                  flat
                  hide-details="auto"
                  class="este-autocomplete-input"
                >
                  <template slot="append">
                    <v-icon>mdi-chevron-down</v-icon>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row class="e-row">
              <v-col cols="12" md="12" class="e-col">
                <label>
                  <span class="label-txt"> Suggested Treatments </span>
                </label>
                <v-autocomplete
                  v-model="form.service_recommended"
                  :items="treatments"
                  item-text="name"
                  item-value="id"
                  multiple
                  chips
                  autocomplete="off"
                  solo
                  outlined
                  flat
                  hide-details="auto"
                  class="este-autocomplete-input"
                >
                  <template slot="append">
                    <v-icon>mdi-chevron-down</v-icon>
                  </template>
                  <template v-slot:selection="data">
                    <v-chip
                      class="este-chip tag-chip px-3"
                      v-bind="data.attrs"
                      :input-value="data.selected"
                    >
                      <span class="pr-2">
                        {{ data.item.name }}
                      </span>
                      <v-icon color="primary" small @click.stop="removeService(data.item)">
                        mdi-close
                      </v-icon>
                    </v-chip>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
             <v-row class="e-row">
              <v-col cols="12" md="12" class="e-col">
                <label>
                  <span class="label-txt"> Comment </span>
                </label>
                <v-text-field v-model="form.comment" autocomplete="off" solo outlined flat
                  hide-details="auto" class="solo-cust" placeholder="Add a comment"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="e-row">
              <v-col cols="6" md="6" class="e-col">
                <label>
                  <span class="label-txt"> Source </span>
                </label>
                <v-select
                  autocomplete="off"
                  :items="source"
                  :rules="rules.source_id"
                  v-model="form.source_id"
                  item-text="name"
                  item-value="id"
                  solo
                  outlined
                  flat
                  class="solo-cust"
                  hide-details="auto"
                >
                  <template slot="append">
                    <v-icon>mdi-chevron-down</v-icon>
                  </template>
                </v-select>
              </v-col>
             
            </v-row>
          </div>
        </v-form>
      </div>
      <div class="form-btn-wrapper">
        <v-btn class="cancel-btn btn-gap" depressed rounded outlined x-large @click="close">
          Cancel
        </v-btn>
        <v-btn
          color="secondary"
          class="b-blue"
          depressed
          :disabled="loading"
          rounded
          x-large
          @click="create"
        >
          Add Lead
        </v-btn>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import { USER } from "../../../store/action-types.js";
import status from "../../../mixins/status.js";
import globalFn from "../../../mixins/globalFn.js";
import sliderFn from "../../../mixins/sliderFn";
import _ from "lodash";
export default {
  mixins: [status, globalFn, sliderFn],
  data: () => ({
    loading: false,
    isTyping: false,
    markAsChase: false,
    markAsChaseAndCallback: false,
    user: JSON.parse(localStorage.getItem("user")),
    tab: null,
    IsDuplicate: false,
    sourceIcon: "",
    emailErrorMessage: "",
    contactErrorMessage: "",
    socialErrorMessage: "",
    form: {
      name: "",
      influencer: "",
      email: "",
      contact_no: "",
      treatment_ids: "",
      branch_id: "",
      source_id: "",
      contact_type: "Client",
      service_recommended: [],
      comment: "",
    },
    rules: {
      influencer: [(v) => !!v || "Please enter influencer"],
      name: [(v) => !!v || "Please enter name"],
      contact_no: [(v) => !!v || "Please enter contact number"],
      branch_id: [(v) => !!v || "Please select branch"],
      treatment_ids: [(v) => !!v || "Please select treatments"],
      source_id: [(v) => !!v || "Please select source"]
    },
    ExistUserId: "",
    callbackDisabled: false,
    validateUserType: "",
  }),
  computed: {
    treatments() {
      if (this.$store.state.treatments.allList) {
        return this.$store.state.treatments.allList;
      }
    },
    branches() {
      if (this.$store.state.branches.allList) {
        return this.$store.state.branches.allList;
      }
    },
    source() {
      if (this.$store.state.source.list) {
        return this.$store.state.source.list;
      }
    },
    campaigns() {
      if (this.$store.state.campaign.all) {
        return this.$store.state.campaign.all;
      }
    },
  },
  created() {
    this.$store.dispatch("treatments/GET_ALL_TREATMENT", "");
    this.$store.dispatch("branches/GET_ALL_BRANCH", "");
    this.$store.dispatch("source/GET_SOURCE", "");
    this.$store.dispatch("campaign/LIST", "");
  },
  methods: {
    async removeCampaign(item) {
      const index = this.form.campaign_ids.findIndex((x) => x.id === item.id);
      if (index >= 0) {
        this.form.campaign_ids.splice(index, 1);
      } else {
        const i = this.form.campaign_ids.findIndex((x) => x === item.id);
        if (i >= 0) this.form.campaign_ids.splice(i, 1);
      }
    },
    close() {
      this.$store.commit("rightSlider/RESET_SLIDER");
    },
    checkForDuplicate() {
      if (!this.form.social_handle.value && !this.form.email.value && !this.form.contact_no.value) {
        this.form.contact_no.error = "";
        this.form.email.error = "";
        this.form.social_handle.error = "";
        this.markAsChase = false;
        this.markAsChaseAndCallback = false;
        this.IsDuplicate = false;
      } else {
        this.CheckEmailDuplicate();
        this.CheckContactDuplicate();
        this.CheckSocialDuplicate();
      }
    },
    async CheckEmailDuplicate() {
      if (this.form.email.value) {
        let formData = {};
        formData.email = this.form.email.value;
        await this.validate(formData, "email");
        this.form.email.error = this.IsDuplicate ? this.emailErrorMessage : "";
      }
    },
    async CheckContactDuplicate() {
      if (this.form.contact_no.value) {
        let formData = {};
        formData.contact_no = this.form.contact_no.value;
        await this.validate(formData, "contact");
        this.form.contact_no.error = this.IsDuplicate ? this.contactErrorMessage : "";
      }
    },
    async CheckSocialDuplicate() {
      if (this.form.social_handle.value) {
        let formData = {};
        let isValid = this.isValidUrl(this.form.social_handle.value);
        console.log(isValid);
        if (isValid) {
          let url = new URL(this.form.social_handle.value);
          this.form.source_id = this.getSourceId(url.origin);
        }
        formData.source_id = this.form.source_id;
        formData.social_handle = this.form.social_handle.value;
        await this.validate(formData, "social");
        this.form.social_handle.error = this.IsDuplicate ? this.socialErrorMessage : "";
      }
    },
    async validate(formData, type) {
      this.IsDuplicate = false;
      this.markAsChase = false;
      this.markAsChaseAndCallback = false;
      this.emailErrorMessage = "";
      this.contactErrorMessage = "";
      this.socialErrorMessage = "";
      this.validateUserType = "";
      this.ExistUserId = "";
      await this.$store
        .dispatch("leads/VALIDATE_LEAD", formData)
        .then((response) => {
          if (response.result === "success" && response.data.status) {
            this.loading = false;
            this.IsDuplicate = response.data.status;
            this.ExistUserId = response.data.user_id;
            this.validateUserType = response.data.user_type_name;
            this.markAsChaseAndCallback = response.data.user_type_name === "Client" ? true : false;
            this.markAsChase = response.data.user_type_name === "Lead" ? true : false;
            if (type === "email") {
              this.emailErrorMessage = response.message;
            }
            if (type === "contact") {
              this.contactErrorMessage = response.message;
            }
            if (type === "social") {
              this.socialErrorMessage = response.message;
            }
          } else if (response.result === "fail") {
            response.type = "error";
            this.loading = false;
            this.$store.dispatch("snackbar/SHOW", response);
          }
        })
        .catch((err) => {
          this.loading = false;
          err.type = "error";
          this.$store.dispatch("snackbar/SHOW", err);
        });
    },
    isValidUrl(_string) {
      const matchPattern = /^(?:\w+:)?\/\/([^\s\.]+\.\S{2}|localhost[\:?\d]*)\S*$/;
      return matchPattern.test(_string);
    },
    getSourceId(url) {
      let id = 0;
      let self = this;
      this.source.some(function (el) {
        if (url.indexOf(el.name.toLowerCase()) != -1) {
          id = el.id;
        }
      });
      return id;
    },
    async removeService(item) {
      const index = this.form.service_recommended.findIndex(x => x.id === item.id)
      if (index >= 0) {
        this.form.service_recommended.splice(index, 1)
      } else {
        const i = this.form.service_recommended.findIndex(x => x === item.id)
        if (i >= 0) this.form.service_recommended.splice(i, 1)
      }
    },
    async create() {
      if (this.$refs.form.validate()) {
        let formData = {};
        formData.contact_no = this.form.contact_no;
        formData.name = this.form.name;
        formData.influencer = this.form.influencer;
        formData.source_id = this.form.source_id;
        formData.branch_id = this.form.branch_id;
        formData.opp_branch_id = this.form.branch_id;
        formData.treatment_ids = this.form.treatment_ids;
        formData.contact_type = 4;
        formData.enquiry_date = new Date().toISOString().split("T")[0];
        formData.follow_up_date = new Date().toISOString().split("T")[0];

        formData.service_recommended = [];
        this.form.service_recommended.forEach((value) => {
          if (value.id) {
            formData.service_recommended.push(value.id);
          } else {
            formData.service_recommended.push(value);
          }
        });

        await this.$store
          .dispatch("opportunities/CREATE", formData)
          .then((response) => {
            if (response.result === "success") {
              this.disabled = false;
               if (this.form.comment) {
                const commentData = new FormData()
                commentData.append(`id`, response.data?.data?.id);
                commentData.append(`comment`, this.form.comment);
                commentData.append(`category`, 'comment');

                this.$store.dispatch('opportunities/ADD_COMMENT', commentData)
               }
              this.loadData();
            } else if (response.result === "fail") {
              response.type = "error";
              this.disabled = false;
              this.$store.dispatch("snackbar/SHOW", response);
            }
          })
          .catch((err) => {
            this.disabled = false;
            err.type = "error";
            this.$store.dispatch("snackbar/SHOW", err);
          });
      }
    },

    loadData() {
      this.$root.$emit("opportunitiesTable", "");
      this.$store.commit("rightSlider/RESET_SLIDER");
    },

    async markToChase(callback, type) {
      let formData = {};
      formData.contact_no = this.form.contact_no.value;
      formData.comment = this.form.comment;
      if (this.form.email.value) {
        formData.email = this.form.email.value;
      }
      formData.source_id = this.form.source_id;
      formData.social_handle = this.form.social_handle.value;
      formData.branch_id = this.form.branch_id;
      formData.treatment_ids = this.form.treatment_ids;
      formData.campaign_ids = this.form.campaign_ids;
      formData.user_exists = this.IsDuplicate;
      formData.user_id = this.ExistUserId;
      formData.user_type = this.validateUserType;
      formData.status = type === "chase" ? 20 : 3;

      this.loading = true;
      await this.$store
        .dispatch("leads/QUICK_LEAD", formData)
        .then((response) => {
          if (response.result === "success") {
            this.loading = false;
            if (callback) {
              this.createCallback();
            } else {
              this.$refs.form.reset();
              this.loadData();
            }
          } else if (response.result === "fail") {
            response.type = "error";
            this.loading = false;
            this.$store.dispatch("snackbar/SHOW", response);
          }
        })
        .catch((err) => {
          this.loading = false;
          err.type = "error";
          this.$store.dispatch("snackbar/SHOW", err);
        });
    },

    async createCallback() {
      this.callbackDisabled = true;
      let formData = {};
      formData.user_id = this.ExistUserId;
      formData.treatment_ids = this.form.treatment_ids;

      await this.$store
        .dispatch("callback/CREATE_CALLBACK_USER", formData)
        .then((response) => {
          if (response.result === "success") {
            this.callbackDisabled = false;
            this.loadData();
            this.$refs.form.reset();
          } else if (response.result === "fail") {
            response.type = "error";
            this.callbackDisabled = false;
            this.$store.dispatch("snackbar/SHOW", response);
          }
        })
        .catch((err) => {
          this.callbackDisabled = false;
          err.type = "error";
          this.$store.dispatch("snackbar/SHOW", err);
        });
    },

    async markToNew() {
      let action =
        this.validateUserType === "Lead" ? "leads/ARCHIVE_LEAD" : "clients/ARCHIVE_CLIENT";
      let status = this.validateUserType === "Lead" ? 3 : 1;
      await this.$store
        .dispatch(action, { id: this.ExistUserId, status: status })
        .then((res) => {
          if (res.result === "success") {
            this.loading = false;
            this.$refs.form.reset();
            this.loadData();
          } else if (res.result === "fail") {
            res.type = "error";
            this.$store.dispatch("snackbar/SHOW", res);
          }
        })
        .catch((err) => {
          err.type = "error";
          this.$store.dispatch("snackbar/SHOW", err);
        });
    },

    async editItem() {
      if (this.validateUserType === "Lead") {
        await this.$store
          .dispatch("leads/SHOW_LEAD", {
            id: this.ExistUserId,
            param:
              "?attributes=staff,branch,leadDetails,reasons,symptoms,treatments,source,campaigns",
          })
          .then((res) => {
            if (this.$vuetify.breakpoint.name === "lg" || this.$vuetify.breakpoint.name === "xl") {
              this.openDrawer("add", "1100", "leads/editPane");
            } else {
              this.openDrawer("add", "750", "leads/editTab");
            }
          });
      } else if (this.validateUserType === "Client") {
        await this.$store
          .dispatch("clients/SHOW_CLIENT", {
            id: this.ExistUserId,
            param:
              "?attributes=staff,branch,clientDetails,reasons,symptoms,treatments,documents,comments,source,campaigns",
          })
          .then((res) => {
            if (this.$vuetify.breakpoint.name === "lg" || this.$vuetify.breakpoint.name === "xl") {
              this.openDrawer("add", "1100", "clients/editPane");
            } else {
              this.openDrawer("add", "750", "clients/editTab");
            }
          });
      }
    },
  },
};
</script>
